import { Polyline } from "@react-google-maps/api"
import CustomGoogleMap from "components/Organisms/map/CustomGoogleMap"
import MapCenterButton from "components/Templates/MapCenterButton"
import { BeatDetailQuery } from "generated/graphql"
import OutletMarker from "pages/fsm/routes/[id]/OutletMarker"
import React from "react"
import { paleMap } from "utils/mapStyles"
import BeatTrackingMarker from "../BeatTrackingMarker"

type BeatTrackingMapType = {
  assignment?: BeatDetailQuery["beatDetail"]["assignment"]
  assignee?: BeatDetailQuery["beatDetail"]["assignee"]
}
const BeatTrackingMap = ({ assignment, assignee }: BeatTrackingMapType) => {
  const outlets = assignment.assignedRoutePoints
  const midPoint = outlets[Math.round(outlets.length / 2)]?.visitee

  return (
    <CustomGoogleMap
      styles={paleMap}
      mapContainerClassName="shadow-sm rounded-md"
      center={{
        lat: midPoint?.address?.latitude,
        lng: midPoint?.address?.longitude,
      }}
    >
      <MapCenterButton
        items={outlets}
        getItemLocation={item => ({
          lat: item.visitee?.address?.latitude,
          lng: item.visitee?.address?.longitude,
        })}
      />
      {assignee && <BeatTrackingMarker assignee={assignee} />}
      {outlets.map((outlet, idx) => {
        return (
          <OutletMarker
            index={idx}
            disabled
            marker={{
              ...outlet.visitee,
              sequence: outlet.visitByBeat ? true : false,
            }}
          />
        )
      })}
      <Polyline
        path={assignment.polyline?.coordinates.map(point => ({
          lat: point[1],
          lng: point[0],
        }))}
        options={{ strokeColor: assignment.route.colorCode }}
      />
    </CustomGoogleMap>
  )
}

export default BeatTrackingMap
